export function readStoredJson(key, fallback = null) {
  try { return JSON.parse(sessionStorage.getItem(key) || 'null') || fallback; }
  catch { return fallback; }
}

// Presentation only. The server independently verifies the signature and payment.
export function paymentExpiry(session) {
  try {
    const body = String(session || '').split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
    const exp = Number(JSON.parse(atob(body.padEnd(Math.ceil(body.length / 4) * 4, '='))).exp);
    return Number.isFinite(exp) && exp > 0 ? exp : 0;
  } catch { return 0; }
}
